var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { makeAutoObservable } from "mobx";
import { Money, Percentage } from "../core";
import { perRestaurant } from "../di";
import { OrderReceiver } from "./OrderReceiver";
import { Payment } from "./Payment";
import { Restaurant } from "./Restaurant";
const SERVICE_FEE_PERCENTAGE = Percentage.fromNumber(1.5);
let ServiceFeeService = class ServiceFeeService {
    constructor(restaurant, payment, orderReceiver) {
        this.restaurant = restaurant;
        this.payment = payment;
        this.orderReceiver = orderReceiver;
        makeAutoObservable(this);
    }
    get isApplicable() {
        if (this.restaurant.orderingPolicy.serviceFeeSettings.tag === "None") {
            return false;
        }
        if (this.restaurant.orderingPolicy.country !== "PL") {
            return false;
        }
        if (this.payment.method !== "Online") {
            return false;
        }
        if (this.orderReceiver.invoiceRequest !== null) {
            return false;
        }
        return true;
    }
    getValue(base) {
        if (!this.isApplicable) {
            return Money.zero();
        }
        if (base.leq(Money.zero())) {
            return Money.zero();
        }
        return base.percentage(SERVICE_FEE_PERCENTAGE);
    }
};
ServiceFeeService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof Restaurant !== "undefined" && Restaurant) === "function" ? _a : Object, typeof (_b = typeof Payment !== "undefined" && Payment) === "function" ? _b : Object, typeof (_c = typeof OrderReceiver !== "undefined" && OrderReceiver) === "function" ? _c : Object])
], ServiceFeeService);
export { ServiceFeeService };
